import {
  HTTP_SELCOMPANYSPECIAL_FETCHING,
  HTTP_SELCOMPANYSPECIAL_SUCCESS,
  HTTP_SELCOMPANYSPECIAL_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "./../../utils/HttpClient";
//   import { async } from "q";

export const setStateSelCompanySpecialToFetching = () => ({
  type: HTTP_SELCOMPANYSPECIAL_FETCHING,
});

export const setStateSelCompanySpecialToSuccess = (payload) => ({
  type: HTTP_SELCOMPANYSPECIAL_SUCCESS,
  payload,
});

export const setStateSelCompanySpecialToFailed = (payload) => ({
  type: HTTP_SELCOMPANYSPECIAL_FAILED,
});

export const getCompanysSpecial = (countryid) => {
  return async (dispatch) => {
    dispatch(setStateSelCompanySpecialToFetching());
    try {
      const result = await httpClient.get(
        `${server.COMPANYSPECIAL_URL}/${countryid}`,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(setStateSelCompanySpecialToSuccess(result.data));
    } catch (error) {
      dispatch(setStateSelCompanySpecialToFailed());
    }
  };
};
